import { makeAutoObservable } from 'mobx';
import { ProjectTemplateModel, createProjectTemplateModel } from '../models/projectTemplate';
import { ProjectTemplateInput, RawProjectTemplate } from '../interfaces/project';
import { rootStore } from '../rootStore';
import { RawFile } from '../interfaces/task';

export class TaskTemplateModel {
  length?: number;
  createdBy?: string;
  createdOn?: string;
  description?: string;
  dueDate?: string;
  name: string = '';
  usersIds?: string[];
  taskUsers?: string[];
  priority?: number | null;
  uploadedFiles?: RawFile;
  files?: RawFile[];
  templateName?: string;
  id?: string;

  constructor() {
    makeAutoObservable(this);
  }

  get users() {
    return rootStore.workspaceStore.currentWorkspace?.users?.filter((user) => this.usersIds?.includes(user.id));
  }

  setTemplateName(templateName: string) {
    this.templateName = templateName;
  }

  setTaskName(name: string) {
    this.name = name;
  }

  setDescription(description: string) {
    this.description = description;
  }

  setPriority(priority: number) {
    this.priority = priority;
  }

  hasAssignee(userId: string) {
    return this.usersIds?.includes(userId);
  }

  addAssignee(userId: string) {
    this.usersIds = [userId];
  }
  removeAssignee(userId: string) {
    this.usersIds = this.usersIds?.filter((id) => id !== userId);
  }

  clearAssignees() {
    this.usersIds = [];
  }

  setFiles(files: RawFile[]) {
    this.files = files;
  }
}

export class ProjectTemplateStore {
  projectTemplates: ProjectTemplateModel[] = [];
  currentProjectTemplate: ProjectTemplateModel | null = null;
  projectTemplateInput: ProjectTemplateInput | null = null;
  currentTaskTemplate: TaskTemplateModel | null = new TaskTemplateModel();
  taskTemplateList: TaskTemplateModel[] = [];
  recommendedTemplates: ProjectTemplateModel[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  setTaskTemplateList(taskTemplateList: TaskTemplateModel[]) {
    this.taskTemplateList = taskTemplateList;
  }

  setCurrentTaskTemplate(templateId: string) {
    this.currentTaskTemplate = this.taskTemplateList.find((x) => x.id === templateId) || new TaskTemplateModel();
  }

  setProjectTemplates(projectTemplates: RawProjectTemplate[]) {
    this.projectTemplates = projectTemplates.map(createProjectTemplateModel);
  }

  setCurrentProjectTemplate(templateId: string) {
    this.currentProjectTemplate = this.projectTemplates.find((template) => template.id === templateId) || null;
  }

  setProjectTemplateInput(projectTemplateInput: ProjectTemplateInput | null) {
    this.projectTemplateInput = projectTemplateInput;
  }

  setRecommendedTemplates(defaultTemplates: RawProjectTemplate[]) {
    this.recommendedTemplates = defaultTemplates.map(createProjectTemplateModel);
  }

  // Clear project template related data
  clearProjectTemplateData() {
    this.projectTemplates = [];
    this.taskTemplateList = [];
    this.projectTemplateInput = null;
    this.currentProjectTemplate = null;
    this.currentTaskTemplate = new TaskTemplateModel();
  }
}

export const projectTemplateStore = new ProjectTemplateStore();
